import overview from './overview';

const namespaced = true;
const state = {};

export default {
  namespaced,
  state,
  modules: {
    overview,
  },
};
